import React, {
  Component
} from 'react';

import EmployeeResultRow from "./EmployeeResultRow";
import Pager from 'react-pager';
import EmployeeFilter from "./EmployeeFilter";
import PermissionHelper from "../../../helpers/PermissionHelper";
import EmployeeActions from "./actions/EmployeeActions";
import EmployeeForm from "./EmployeeForm";

import {
  MDBSpinner,
  MDBTable,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBInput,
  MDBSelect,
  MDBCollapseHeader,
  MDBIcon,
  MDBCollapse,
  MDBPagination,
  MDBPageItem,
  MDBPageNav
} from 'mdbreact';

import moment from 'moment';
import 'moment/locale/de';

import config from '../../../config';



class EmployeeSearch extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      result: [],
      page: 0,
      limit: 10,
      total: 0,
      visiblePage: 5,
      rolesFilter: [],
      locationsFilter: [],
      logindaysFilter: [],
      locations: [],
      roles: [],
      filters: {
        field_location: null,
        field_role: null,
        field_sort: 'ufd.changed',
        field_sort_direction: 'desc'
      },
      sortOptions: [
        {
          checked: true,
          text: 'Geändert',
          value: 'ufd.changed'
        },
        {
          text: 'Nachname',
          value: 'uf_lastname.field_lastname_value'
        }
      ]
    }

    this.formRef = React.createRef();

    this._onHandlePageChanged = this._onHandlePageChanged.bind(this);
    //console.log(props);
  }

  _onHandlePageChanged(newPage) {
    this.setState({
        page: newPage
    }, () => {
        this.loadEmployeeCollection();
    });
  }

  componentDidMount() {
    this.loadEmployeeCollection();
    //console.log(this);
  }

  loadEmployeeCollection() {


      var component = this;

      component.setState({
        collectionLoaded: false
      });

      /** build filter query **/
      EmployeeActions._get('All', this.state.filters, this.state.page).then(response => {
        //  console.log(response.data.entity);
        //console.log(response.data.result);


        var result = [];
        if(response.data.result) {
          result = Object.entries(response.data.result);
        }

        var locations = response.data.locations;
        var locationsFilter = new Array();
        if(locations) {
          Object.entries(locations).forEach(function(item, key){
            var optionItem = {
              text: item[1].title[0].value,
              value: item[0]
            }
            locationsFilter.push(optionItem);
            //console.log(item);
          });
        }

        if(this.state.locationsFilter.length == 0) {
          component.setState({
            locationsFilter: locationsFilter,
            locations: locations,
          });
        }



        var logindays = response.data.logindays;
        var logindaysFilter = new Array();
        if(logindays) {
          Object.entries(logindays).forEach(function(item, key){
            var optionItem = {
              text: item[1].name[0].value,
              value: item[0]
            }
            logindaysFilter.push(optionItem);
            //console.log(item);
          });
        }

        if(this.state.logindaysFilter.length == 0) {
          component.setState({
            logindaysFilter: logindaysFilter,
            logindays: logindays,
          });
        }


        var roles = response.data.roles;

        var rolesFilter = new Array();
        if(roles) {
          Object.entries(roles).forEach(function(item, key){
            //console.log(item);
            var optionItem = {
              text: item[1].label,
              value: item[1].id
            }
            rolesFilter.push(optionItem);
            //console.log(item);
          });
        }

        if(this.state.rolesFilter.length == 0) {
          component.setState({
            rolesFilter: rolesFilter,
            roles: roles,
          });
        }



        component.setState({
          result: result,
          loaded: true,
          collectionLoaded: true,
          total: response.data.total
        });

      });
  }

  render() {
    let component = this;
    return (
      <>

        {!this.state.loaded &&
          <div className="text-center"><MDBSpinner key={'employee-loader'} red /></div>
        }

        {component.state.loaded && (
          <>
            {PermissionHelper._hasPermission('restful post Employee') === true &&
              <>
                <EmployeeForm searchComponent={this} ref={this.formRef} />
              </>
            }

            <EmployeeFilter searchComponent={component} />
            <hr />
            { component.state.result.length > 0 && (
              <MDBTable responsive hover striped>
                <thead>
                  <tr>
                    <th className='th-lg'>
                      Mitarbeiternummer
                    </th>

                    <th className='th-lg'>
                      Vorname
                    </th>
                    <th className='th-lg'>
                      Nachname
                    </th>
                    <th className='th-lg'>
                      E-Mail
                    </th>
                    <th className='th-lg'>
                      Telefon
                    </th>

                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {true && (
                    component.state.result.map(function(row, j){
                      //console.log(row)
                      return (
                        <EmployeeResultRow result={row[1]}  key={'employee-result-view-' + row[1].uid  + row[1].changed} searchComponent={component} />
                      )
                    })
                  )}
                </tbody>
              </MDBTable>
            )}

            {component.state.result.length == 0 &&
              <div className="empty">Keine passenden Geschäfte</div>
            }

            {component.state.loaded && component.state.total > 10 && (
              <>
                <hr />
                <Pager
                      total={Math.ceil(this.state.total / this.state.limit)}
                      current={this.state.page}
                      visiblePages={this.state.visiblePage}
                      titles={{ first: '<|', last: '>|' }}
                      className="pagination-sm pull-right"
                      onPageChanged={this._onHandlePageChanged}
                  />
              </>
            )}
          </>
        )}

      </>
    );
  }
}

export default EmployeeSearch;
